import { render, staticRenderFns } from "./deals.vue?vue&type=template&id=115484e7&scoped=true&"
import script from "./deals.vue?vue&type=script&lang=js&"
export * from "./deals.vue?vue&type=script&lang=js&"
import style0 from "./deals.vue?vue&type=style&index=0&id=115484e7&scoped=true&lang=css&"
import style1 from "./deals.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115484e7",
  null
  
)

export default component.exports